import { OrbitControls, Sparkles } from "@react-three/drei";
import { Perf } from "r3f-perf";
import Lights from "./Lights.jsx";
import { Physics } from "@react-three/rapier";
import Surface from "./Surface.jsx";
import Car from "./Car.jsx";
import "./materials/registerMaterials.js";

import StartLocation from "./components/mainareas/StartLocation.jsx";
import Crossroad from "./components/mainareas/Crossroad.jsx";
import GameZone from "./components/mainareas/GameZone.jsx";
import WorkZone from "./components/mainareas/WorkZone.jsx";
import Hobby from "./components/mainareas/Hobby.jsx";
import { useButtonHandler } from "./hooks/useButtonHandler.jsx";
import { Suspense, useEffect } from "react";
import { useLoading } from "./stores/useLoading";
import { COLORS } from "./constants/colors";

const spawn = {
  position: [0, 1, -12],
  rotation: [0, Math.PI / 2, 0],
};

const initialRacePosition = {
  position: [-8, -0.99, 0],
  position2: [-20, 0, 14],
  rotation: [0, -Math.PI / 2, 0],
};

export default function Experience() {
  // Используем кастомный хук для обработки кнопок
  useButtonHandler();

  // Управление состоянием загрузки
  const setExperienceReady = useLoading((state) => state.setExperienceReady);
  const shouldShowExperience = useLoading(
    (state) => state.shouldShowExperience
  );

  useEffect(() => {
    // Когда Experience полностью смонтирован и все ресурсы загружены
    setExperienceReady(true);

    return () => {
      setExperienceReady(false);
    };
  }, [setExperienceReady]);

  return (
    <>
      {/* <Perf position="top-left" /> */}
      <color attach="background" args={[COLORS.background]} />

      <Physics
        debug={false}
        gravity={[0, -9.81, 0]}
        timeStep={1 / 60}
        maxStabilizationIterations={1}
        maxVelocityIterations={4}
        maxVelocityFrictionIterations={1}
        maxCcdSubsteps={1}
      >
        <Lights />

        {/* Скрываем содержимое Experience визуально до клика на кнопку */}
        <group visible={shouldShowExperience}>
          <Car
            position={spawn.position}
            rotation={spawn.rotation}
            initialRacePosition={initialRacePosition.position2}
            initialRaceRotation={initialRacePosition.rotation}
          />
          <Surface />
          <StartLocation position={[3.75, 0, -5]} />
          <Crossroad position={[0, 0, 25]} />
          <GameZone position={[-36.5, 0, 26.5]} />
          <WorkZone position={[62.25, 0, 21]} />
          <Hobby position={[12.5, 0, 53.5]} />
        </group>
      </Physics>
    </>
  );
}
